import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
  {
    variants: {
      variant: {
        default: "bg-[var(--color-panel-2)] text-[var(--color-fg)]",
        good: "bg-[var(--color-good)]/15 text-[var(--color-good)] border border-[var(--color-good)]/30",
        bad: "bg-[var(--color-bad)]/15 text-[var(--color-bad)] border border-[var(--color-bad)]/30",
        warn: "bg-[var(--color-warn)]/15 text-[var(--color-warn)] border border-[var(--color-warn)]/30",
        outline: "border border-[var(--color-border)] text-[var(--color-muted)]",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>;
export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
